<template>
    <div class="col-md-9">
        <!-- <div class="h-100" v-if="loading">
            <div class="spinner"></div>
        </div> -->
        <div class="fetchposts-app">
            <!-- Titles -->
            <h1 class="h3 grey-bg p-3">
                <span v-if="selectedTermsObjects.length > 0" >
                    נמצאו {{ filteredPosts.length }} מסעדות 
                    <!-- <div class="tax-review" v-for="(terms, label) in taxonomyTerms" :key="label">
                        <span>{{ label }} - &nbsp;</span>
                        <ul class="tax-review-terms">
                            <li class="d-inline-block" v-for="term in terms" :key="term.term_id">
                               <span>{{ term.name }}</span> 
                            </li>
                        </ul>
                    </div> -->
                </span>
                <span v-else>
                    נמצאו {{ posts.length }} מסעדות 
                </span>
            </h1>
            <!-- Post -->
            <ul class="fetchpost" v-if="paginatedPosts">
                <li v-for="(post ,index) in paginatedPosts" :key="index">
                    <div v-if="loading">
                        <content-loader
                            viewBox="0 0 476 150"
                            primaryColor="#e3e3e3"
                            secondaryColor="#cccccc"
                            :rtl="true"
                            :speed = 1
                            >
                            <!-- img -->
                            <rect x="280" y="0" cx="10" cy="20" r="8" width="280" height="280" />
                            <!-- terms -->
                            <rect x="120" y="5" cx="8" cy="8" rx="8" ry="8" width="40" height="15" />
                            <rect x="170" y="5" cx="8" cy="8" rx="8" ry="8" width="40" height="15" />
                            <rect x="220" y="5" cx="8" cy="8" rx="8" ry="8" width="40" height="15" />
                            <!-- txt -->
                            <rect x="60" y="45" rx="3" ry="3" width="200" height="8" />
                            <rect x="60" y="65" rx="3" ry="3" width="200" height="8" />
                            <rect x="60" y="85" rx="3" ry="3" width="200" height="8" />
                            <rect x="60" y="105" rx="3" ry="3" width="200" height="8" />
                            <!-- button -->
                            <rect x="180" y="135" cx="1" cy="1" rx="1" ry="1" width="80" height="15" />
                        </content-loader>
                    </div>
                    <div v-else class="row align-items-center">
                        <div class="col-md-5 col-12">
                            <div class="img-wrap">
                                <div>
                                    <ImageLoadingBox ref="img" :postImgCrs="post.imageCrs"></ImageLoadingBox>
                                </div>
                            </div> 
                        </div>
                        <div class="col-md-7 col-12">
                            <div class="post-details-wrap h-100">
                                <div v-if="post.attached_terms" class="taxterms">
                                    <span v-for="(term ,index) in post.attached_terms" :key="index">
                                        {{ term.name }}
                                    </span>
                                </div>
                                <h3 class="">{{ post.title.rendered }}</h3>
                                <div class="content" v-html="post.content.rendered"></div>
                                <div class="place-details">
                                    <span class="phone">
                                        <h5 v-if="post.acf.phone"> <span class="icon"><font-awesome-icon icon="fa-solid fa-phone-flip" style="color: #003d88;" /></span>
                                            <a :href="'tel:'+ post.acf.phone">{{post.acf.phone}}</a>
                                        </h5>
                                    </span>
                                    <span class="address">
                                        <h5 v-if="post.acf.address"><span class="icon"><font-awesome-icon icon="fa-solid fa-location-dot" style="color: #003d88;" /></span> 
                                            <a v-if="post.acf.waze_link" :href="post.acf.waze_link" target="_blank">{{post.acf.address}}</a>
                                            <span v-else >{{post.acf.address}}</span>
                                        </h5>
                                    </span>
                                </div>
                                <div class="post-links row">
                                    <div class="col-sm-6 col-xs-6">
                                        <button v-if="post.acf.website_link" ><a :href="post.acf.website_link" target="_blank"> לאתר </a></button>
                                    </div>
                                    <div class="col-sm-6 col-xs-6">
                                        <button v-if="post.acf.link_to_menu" ><a :href="post.acf.link_to_menu" target="_blank"> לתפריט </a></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <!-- Pagination -->
            <div v-if="totalPages > 1" class="pagination-wrap">
                <ul class="pagination">
                    <li v-for="page in totalPages" :key="page" :class="{ active: currentPage === page }">
                        <a href="#" @click.prevent="changePage(page)">{{ page }}</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
  
<script>
import api from '@/api/index';
import ImageLoadingBox from "@/components/ImageLoadingBox";
import { ContentLoader } from "vue-content-loader";

export default {
    name:'ListPost',
    components: {
        ImageLoadingBox,
        ContentLoader
    },
    props: {
        selectedTerms:{},
        selectedTermsObjects:{},
    },
    data() {
        return {
            loading: true,
            posts: [], // Array to store all fetched posts
            filteredPosts: [], // Array to store filtered posts based on selected terms
            currentPage: 1,
            postsPerPage: 5,
            terms: {},
            $router:'',
            postImgCrs:'',
            taxonomyTerms:{}
        };
    },
    mounted() {
        this.loading = true
        this.fetchPosts();
    },
    created() {
        const language = window.__LANGUAGE__;
    },
    computed: {
        totalPages() {
            return Math.ceil(this.filteredPosts.length / this.postsPerPage)
        },
        paginatedPosts() {
            const startIndex = (this.currentPage - 1) * this.postsPerPage
            const endIndex = startIndex + this.postsPerPage
            return this.filteredPosts.slice(startIndex, endIndex);
        },
    },
    watch: {
        selectedTerms: function (valSlug) {
            console.log('valSlug',valSlug)
            this.currentPage = 1
            
            this.filterPosts();
            // if(Object.keys(valSlug).length === 0){
            //     this.fetchPosts()
            // }else{
            //     this.loading = true
            //     this.filterPosts(valSlug) 
            // }
        },
        selectedTermsObjects: function (valObj, oldValue) {

            console.log('valObj',valObj)
            console.log('oldValue',oldValue)

            let taxonomyLabels = new Set();
            valObj.forEach(term => {
                taxonomyLabels.add(term.taxonomy_label);
            });

            // Loop through the set and find terms for each taxonomy label
            taxonomyLabels.forEach(label => {
                let terms = valObj.filter(term => term.taxonomy_label === label);
                this.taxonomyTerms[label] = terms;
            });
            console.log('unique tax terms',this.taxonomyTerms);
        },
    },
    methods: {
        changePage(page) {
            this.currentPage = page
        },
        async fetchPosts() {
            const language = window.__LANGUAGE__
            console.log('window',window)
            // console.log('language',this.language)
            // const language = 'en';
            let endpoint = '/getposts/'
            let queryParam = 'restaurants'
            let lang = '?lang=' + language

            let query = endpoint + queryParam + lang

            api.get( query ).then(response => {
                console.log('response.data',response.data)
                this.posts = response.data.map(post => ({
                    id: post.id,
                    title: post.title,
                    content: post.content,
                    acf: post.acf,
                    featured_media: post.featured_media,
                    imageCrs: post.image_post.src,
                    imageAlt : post.image_post.alt,
                    attached_terms : post.attached_terms
                }))

                this.filterPosts();

                setTimeout(() => {
                    this.loading = false
                }, 800);
                
            })
            .catch(error => {
                console.error(error);
            });
            
        },

        filterPosts() {
            if (this.selectedTerms.length === 0) {
                this.filteredPosts = this.posts;
            } else {
                this.filteredPosts = this.posts.filter(post => {
                    // console.log('Current Post:', post.attached_terms);
                    const matches = this.selectedTerms.every(selectedTerm => {
                        const termMatches = post.attached_terms.some(postTerm => {
                            // console.log('Post Term:', postTerm);
                            return selectedTerm.includes(postTerm.slug);
                        });
                        // console.log('Term Matches:', termMatches);
                        return termMatches;
                    });
                    // console.log('All Terms Matched:', matches);
                    return matches;
                });

                if(this.filteredPosts.length>0){
                    setTimeout(() => {
                        this.loading = false
                    }, 200);
                }
            

                const terms = this.filteredPosts.reduce((result, post) => {
                result.push(...post.attached_terms);
                return result;
                }, []);
                const filteredTerms = [...new Map(terms.map(term => [term.slug, term])).values()];
                console.log('filteredTerms',filteredTerms)

                this.$emit('update-terms', filteredTerms);
            }
        },
        // async filterPosts(val){
        //     // const language = 'en';
        //     const language = window.__LANGUAGE__;
        //     // console.log('language',this.language)
        //     let endpoint = 'filter/'
        //     let queryParam  = this.selectedTerms.join('/')
        //     let lang = '?lang=' + language

        //     let query = endpoint + queryParam + lang

        //     console.log('query',query)
            
        //     api.get( query )
        //     .then(response => {
        //         this.posts = response.data.map(post => ({
        //             id: post.id,
        //             title: post.title,
        //             content: post.content,
        //             acf: post.acf,
        //             featured_media: post.featured_media,
        //             imageCrs: post.image_post.src,
        //             imageAlt : post.image_post.alt,
        //             attached_terms : post.attached_terms
        //         }))

        //         // const terms = this.posts.reduce((result, post) => {
        //         // result.push(...post. );
        //         // return result;
        //         // }, []);
        //         // const filteredTerms = [...new Map(terms.map(term => [term.slug, term])).values()];
        //         // console.log('filteredTerms',filteredTerms)

        //         // this.$emit('update-terms', filteredTerms);
        //         setTimeout(() => {
        //             this.loading = false
        //         }, 20);
        //         // this.loading = false
        //     }).catch(error => {
        //         console.log(error);
        //     });
        // },
    }
};
</script>

<style scoped>
.tax-review,
.tax-review *{
    display: inline-block;
    margin-bottom: 0;
}
.tax-review{
    padding: 0 15px;
    border-left: 1px solid #000 ;
}
.tax-review:last-child {
    border-left: 0px solid #000 ;
}
ul.tax-review-terms li:after{
    position: absolute;
    content: ',';
}
ul.tax-review-terms li:last-child:after{
    position: absolute;
    content: '';
}
.tax-review ul li{
    /* font-size: 1rem; */
    position: relative;
    padding: 0 5px;
}
.fetchposts-app h1{
    padding: 1rem;
    margin-top: 0;
}
ul {
    list-style: none;
    padding: 0;
}
ul.fetchpost li .content{
    font-size: initial;
}
ul.fetchpost li{
    border: 0;
    margin-bottom: 1.3rem;
    background-color: #fafafa;
    padding: 1rem;
}
ul.fetchpost li > div.row {  
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    flex:1 1 auto;
}
.taxterms span{
    border-radius: 15px;
    padding: 4px 8px;
    border: 1px solid #ccc;
    margin: 0 4px 10px;
    font-size: 0.78rem;
    min-width: 2rem;
    display: inline-block;
    text-align: center;
}
.post-details-wrap{
    position: relative;
}
.post-details-wrap h5,
.post-details-wrap h3{
    font-weight: 600;
    margin-top: 5px;
}
.place-details span a,
.place-details span{
    display: inline-block;
    padding: 0 0 0 5px;
    font-weight: 600;
    color: #000;
}
.place-details h5{
    margin-bottom: 0;
    margin-left: 1rem;
    line-height: 1;
}
.row.post-links{
    position: absolute;
    width: 100%;
    bottom: 0;
}
.post-links button{
    border: 0;
    background-color: #003d88;
    padding: 4px 0rem;
    width: 100%;
    margin-top: 1.2rem;
    font-weight: 500;
}
button a{
    display: block;
    width: 100%;
    color: #fafafa;
    text-decoration: none;
    font-size: 1.2rem;
    font-weight: 300;
}
.pagination-wrap .pagination {
    text-align: start;
}
.pagination-wrap .pagination li{
    display: inline-block;
    padding: 0.2rem 0.4rem;
    margin: 0 4px;
    border: 1px solid;
}
.pagination-wrap .pagination>li>a{
    color: black;
    display: block;
    padding: 0.2rem;
    border-radius: 0;
    border: 0;
}
.pagination-wrap .pagination li:hover,
.pagination-wrap .pagination li.active{
    background: #003d88;
}
.pagination-wrap .pagination li:hover a,
.pagination-wrap .pagination li.active a{
    color: #fff;
    background: #003d88;
    border: 0px solid #fff;
}
/* mobile */
@media only screen and (max-device-width: 640px), only screen and (max-device-width: 667px), only screen and (max-width: 480px) and (orientation : landscape) {
    .row.post-links{
        position: relative;
    }
    ul.fetchpost li > div.row{
        display: block;
    }
    .taxterms span{
        margin-top: 1rem;
    }
    /* .post-links button{
        width: 50%;
    } */
}
</style>